<section
  class="flex w-full items-center bg-gradient-to-r from-[#0b254e] to-[#154fa0] px-4 py-6 text-white"
  aria-labelledby="orders-dashboard-summary-heading"
>
  <h2 id="orders-dashboard-summary-heading" class="sr-only">Orders summary</h2>

  <!-- Left column: centered -->
  <div class="flex flex-1 items-center justify-center">
    <app-totals-display
      class="flex self-center"
      [activeLocations]="(totalActiveLocations$ | async) || 0"
      [activeOrders]="(activeOrders$ | async)?.length || 0"
    ></app-totals-display>
  </div>

  <!-- Right column: aligned right -->
  <div class="hidden flex-1 items-center justify-end gap-6 md:flex lg:gap-12">
    <app-active-order-chart
      [data]="orderResCurr"
      [order]="activeOrders$ | async"
      [loading]="false"
      class="flex shrink-0 justify-center self-center"
    ></app-active-order-chart>

    <div class="shrink-0 flex-col gap-1 self-end lg:flex">
      <a
        routerLink="/orders/insights"
        class="flex items-center gap-1 font-lato text-sm font-medium text-white transition-opacity hover:opacity-75"
        aria-label="View order insights, including milestones, activation status, and in-progress services"
      >
        View order insights
        <mat-icon
          class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
          aria-hidden="true"
          >arrow_forward</mat-icon
        >
      </a>
      <p class="font-lato text-xs text-white/50">
        Milestones, activation status, and in-progress services
      </p>
    </div>
  </div>
</section>
